import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ContactsApiProvider } from '../../services';
import logo from 'assets/img/logo-xomePro.png';

const Error = (props) => {

  useEffect(() => {
    const logError = async () => {
        if(props.error != null || props.errorInfo != null) {
            var errorObj = {
                errorInfo: props.errorInfo,
                errorMessage: props.error.message,
                errorStack: props.error.stack
            };
            await ContactsApiProvider.post("/logerrors", {
                error: JSON.stringify(errorObj)
            })(()=>{}, ()=>{});
        }
    }
    try {
        logError();
    } catch(error) {
        console.log(error);
    }
  }, [props.error, props.errorInfo]);

  const reset = () => {
    props.reset();
  }

  return (
    <div className='login-background background-header bg_img'>
      <div className='header-logo'>
        <img className='header-logo-image' src={logo} />
      </div>
      <div className='login-content'>
        <div className='password-container'>
          <div className='login-bold-header'>
            An Error has occurred. We will try to fix it as soon as possible. 
          </div>
          <div className='login-primary-text forgot-password-text'>
            <Link to='/' onClick={reset}>Go to Dashboard</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error;
